import React, { useRef, useLayoutEffect } from 'react';
import './FixedFooter.scss';
import PropTypes from 'prop-types';

const FixedFooter = ({ title }) => {
  const titleRef = useRef();
  useLayoutEffect(() => {
    setTimeout(() => {
      window
        .$(titleRef.current)
        .attr('href', window.location.href)
        .html(title)
        .shuffleLetters({});
    }, 400);
  }, [title]);
  return (
    <footer className="fixed-footer">
      <div className="footer-social">
        <ul>
          <li>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-facebook" />
            </a>
          </li>
          <li>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
              <i className="fa fa-instagram" />
            </a>
          </li>
        </ul>
      </div>
      <div className="footer-title">
        <h2>
          <a ref={titleRef} href="/">
            {' '}
          </a>
        </h2>
      </div>
    </footer>
  );
};

FixedFooter.propTypes = {
  title: PropTypes.string
};

export default FixedFooter;
